// extracted by mini-css-extract-plugin
module.exports = {"search-view-root":"SearchView_search-view-root__3R1Hj"};